/**
 * interviewExitGuard.js — F-103: the universal interview exit-guard copy + CTA styles, in ONE place so the
 * voice screen (VoiceInterview.js) and the text screen (StRecordPage.js) render the byte-identical dialog and
 * cannot drift (Change Protocol rule 3). Copy is founder-LOCKED (F-102/F-103 ratification) — do not edit
 * without a fresh ratification. The button LABEL "Finish my story" is DONE_BUTTON_LABEL (interviewEngine.js),
 * imported by the callers; this module owns the dialog title/sub/leave + the dock helper + the below-floor nudge.
 *
 * VISUAL: reuses the EXACT F-80 doorway components (StTalkHome.js .tb-primary / .tb-ghost). Constitution
 * negative — gold/amber is NEVER on interactive elements; the primary CTA is the Pip-orange doorway pill.
 * Gold/amber stays only on non-interactive accents (the meter fill, the reveal ribbon), untouched by this pass.
 */

// ── Founder-LOCKED copy (verbatim; no em-dashes) ──
export const EXIT_GUARD_TITLE = 'Your interview will be lost unless Pip writes your story';
export const EXIT_GUARD_SUB = 'None of this is kept until Pip writes it up. Finish first, then decide.';
export const EXIT_GUARD_LEAVE = 'Leave without keeping';
export const DOCK_HELPER = "This writes up your story. You'll see it first, and nothing saves until you choose.";
export const BELOW_FLOOR_NUDGE = 'Tell me just a little more, and I can write your story.';

// ── Exact F-80 doorway CTA styles (StTalkHome.js .tb-primary / .tb-ghost) — reused, not approximated ──
export const CTA_PRIMARY = {
  width: '100%',
  background: 'linear-gradient(180deg,#AE6015,#A85A0F)',
  color: '#fff',
  border: 'none',
  borderRadius: 18,
  padding: 20,
  fontFamily: "'Lora', serif",
  fontSize: 22,
  fontWeight: 700,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 13,
  boxShadow: '0 4px 16px rgba(168,90,15,.3)',
  cursor: 'pointer',
  WebkitTapHighlightColor: 'transparent',
  transition: 'transform .1s ease',
};

export const CTA_SECONDARY = {
  width: '100%',
  background: '#FFFDF8',
  color: '#92400E',
  border: '1px solid #B8813E',
  borderRadius: 16,
  padding: 15,
  fontFamily: "'Lora', serif",
  fontSize: 17,
  fontWeight: 600,
  cursor: 'pointer',
  WebkitTapHighlightColor: 'transparent',
  transition: 'transform .1s ease',
};

// Soft LIGHT overlay (no-dark-surfaces rider) — replaces the old heavy dark scrim.
export const EXIT_GUARD_SCRIM = {
  position: 'fixed',
  inset: 0,
  background: 'rgba(249,246,239,.62)',
  backdropFilter: 'blur(2px)',
  WebkitBackdropFilter: 'blur(2px)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: 16,
  zIndex: 1000,
};

export const EXIT_GUARD_CARD = {
  background: '#FFFDF8',
  border: '1px solid #ece2cf',
  borderRadius: 20,
  padding: '24px 20px 18px',
  width: '100%',
  maxWidth: 420,
  boxShadow: '0 8px 28px rgba(90,66,6,.14)',
  textAlign: 'center',
};
